import { useEffect, useState } from 'react'

interface LogoProps {
  type?: 'full' | 'loyalty' | 'icon'
  className?: string
  alt?: string
}

export default function Logo({ type = 'full', className = '', alt }: LogoProps) {
  const [isDark, setIsDark] = useState(false)

  useEffect(() => {
    // Check initial theme
    const checkTheme = () => {
      const isDarkMode = document.documentElement.classList.contains('dark') ||
        (!document.documentElement.classList.contains('light') && 
         window.matchMedia('(prefers-color-scheme: dark)').matches)
      setIsDark(isDarkMode)
    }

    checkTheme()

    // Listen for theme changes
    const observer = new MutationObserver(checkTheme)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    mediaQuery.addEventListener('change', checkTheme)

    return () => {
      observer.disconnect()
      mediaQuery.removeEventListener('change', checkTheme)
    }
  }, [])

  const getLogoSrc = () => {
    switch (type) {
      case 'full':
        return '/vapourvape-fulltext.svg'
      case 'loyalty':
        return '/loyalty-text.svg'
      case 'icon':
        return '/vapourvape-logo.svg'
      default:
        return '/vapourvape-fulltext.svg'
    }
  }

  const getDefaultAlt = () => {
    switch (type) {
      case 'full':
        return 'VapourVape Logo'
      case 'loyalty':
        return 'Loyalty Text'
      case 'icon':
        return 'VapourVape Icon'
      default:
        return 'VapourVape Logo'
    }
  }

  return (
    <img 
      src={getLogoSrc()}
      alt={alt || getDefaultAlt()}
      className={`transition-all duration-200 ${className}`}
      style={{
        filter: isDark ? 'invert(1) brightness(0.9)' : 'none'
      }}
    />
  )
}